import React, {createContext, useContext, useState} from "react";

const KeyMomentActiveFiltersContext = createContext();

export const KeyMomentActiveFiltersProvider = ({ children }) => {
    const [keyMomentActiveFilters, setKeyMomentActiveFilters] = useState({});
    const [keyMomentSearchOptions, setKeyMomentSearchOptions] = useState();

    function setKeyMomentSearchOption(fieldName, value){
        const tempSearchOptions = {...keyMomentSearchOptions};
        tempSearchOptions[fieldName] = value
        setKeyMomentSearchOptions(tempSearchOptions);
    }

    const handleKeyMomentActiveFilter = (name, value, type = '') => {
        const tempActiveFilters = {...keyMomentActiveFilters}
        tempActiveFilters[name] = value;
        tempActiveFilters.lastTypeModified = type;
        setKeyMomentActiveFilters(tempActiveFilters);
    }

    const resetKeyMomentActiveOption = () => {
        setKeyMomentActiveFilters({});
        setKeyMomentSearchOptions();
    }

    return (
        <KeyMomentActiveFiltersContext.Provider value={{keyMomentActiveFilters, setKeyMomentActiveFilters, handleKeyMomentActiveFilter, setKeyMomentSearchOption, keyMomentSearchOptions, resetKeyMomentActiveOption }}>
            {children}
        </KeyMomentActiveFiltersContext.Provider>
    );
};

export const useKeyMomentActiveFilters = () => {
    const context = useContext(KeyMomentActiveFiltersContext);
    if (!context) {
        throw new Error("useActiveFilters deve essere usato dentro ActiveFiltersProvider");
    }
    return context;
};